module.exports = __webpack_public_path__ + "img/l-cb6-100-2.c445fd78.gif";